<div class="container-fluid h-100">
  <div class="mainContainer text-grey">
    <div class="actionBar">
      <button
        *ngIf="
          showAttachDeployment &&
          (currentUserRole === 'Global Admin' ||
            currentUserRole === 'Deployment Admin')
        "
        class="default-btn"
        style="border: 1px solid var(--s-primary-color)"
        title="Attach Deployment"
        (click)="attachDeployment()"
      >
        Attach Deployment
      </button>
    </div>
    <div *ngIf="showDataEmpty" class="showDataEmpty">
      <p>No deployment attached to user.</p>
    </div>
    <div class="overflow-auto" *ngIf="!showDataEmpty">
      <table
        class="table table-hover"
        [ngClass]="showAttachDeployment ? 'mt-1' : 'mt-0'"
      >
        <thead>
          <tr class="table-list-head">
            <th resizable scope="col">Sr no.</th>
            <th resizable scope="col">Deployment Name</th>
            <th resizable scope="col">Job Submit User</th>
            <th resizable scope="col">User Role</th>
            <th resizable scope="col">Sessions</th>
            <th resizable scope="col">Storages</th>
            <!-- <th resizable scope="col">Mapped Workstation</th> -->
            <th resizable scope="col">Node Group</th>
            <th resizable scope="col">Job Priority</th>
            <th resizable scope="col">Session UserID</th>
            <th *ngIf="isMonitor == false" resizable scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="table-list-row"
            *ngFor="let userInfo of userInfoesData; let i = index; trackBy: trackByDeploymentFunction"
          >
            <td>{{ i + 1 }}</td>
            <td>{{ userInfo.deploymentName }}</td>
            <td>
              {{
                userInfo.jobSubmitId ? userInfo.jobSubmitId : selectedUserName
              }}
            </td>
            <td>{{ userInfo.userRole | userRole }}</td>
            <td *ngIf="userInfo.session.length != 0">
              <select style="max-width: 50% !important">
                <option
                  value="session"
                  *ngFor="let session of userInfo.session"
                >
                  {{ session }}
                </option>
              </select>
            </td>
            <td *ngIf="userInfo.session.length == 0">NA</td>
            <td *ngIf="userInfo.assignedStorages.length != 0 && userInfo.isVdi == false">
              <select style="max-width: 50% !important">
                <option
                  value="storage"
                  *ngFor="let storages of userInfo.assignedStorages"
                >
                  {{ storages }}
                </option>
              </select>
            </td>
            <td *ngIf="userInfo.assignedStorages.length == 0 || userInfo.isVdi == true">NA</td>
            <!-- <td>{{ !userInfo.mappedWorkstation ? "NA" : userInfo.mappedWorkstation}}</td> -->
            <!-- <td>{{ !userInfo.nodeGroup ? " Default" : userInfo.nodeGroup }}</td> -->
            <td>
              <ng-container *ngIf="userInfo.nodeGroup; else defaultNodeGroup">
                <select style="max-width: 50% !important">
                  <option
                    *ngFor="let node of userInfo.nodeGroup.split(',')"
                    [value]="node.trim()"
                  >
                    {{ node.trim() }}
                  </option>
                </select>
              </ng-container>
              <ng-template #defaultNodeGroup> Default </ng-template>
            </td>
            <td>{{ userInfo.jobPriority }}</td>
            <td>{{ userInfo.sessionUserId }}</td>
            <td *ngIf="userInfo.toShowActions && isMonitor == false">
              <button
                class="actionBtn fs-5"
                (click)="
                  updateUserRole(
                    userInfo.userRole,
                    userInfo.deploymentName,
                    userInfo.nodeGroup,
                    userInfo.jobPriority,
                    userInfo.jobSubmitId,
                    userInfo.profileCoreQuota,
                    userInfo.mappedWorkstation,
                    userInfo.userAppDetails,
                    userInfo.sessionUserId,
                    userInfo.isVdi,
                    userInfo.assignedStorages[0]
                  )
                "
                placement="top auto"
                container="body"
                triggers="hover"
                ngbTooltip="Update access control"
              >
                <span><i class="bi bi-pencil-square"></i></span>
              </button>
              <button
                class="actionBtn fs-5"
                *ngIf="showDetachButton == true"
                (click)="
                  detachDeployment(userInfo.userRole, userInfo.deploymentName, userInfo.isVdi)
                "
                placement="top auto"
                container="body"
                triggers="hover"
                ngbTooltip="Detach deployment"
                [ngClass]="{ disabledBtn: userInfo.isGroupAttached }"
              >
                <span><i class="bi bi-x-lg"></i></span>
              </button>
            </td>
            <td *ngIf="!userInfo.toShowActions">NA</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="isLoading" style="margin-top: 300px">
        <ngx-spinner
          bdColor="rgba(0,0,0,0)"
          size="default"
          color="var(--s-primary-color)"
          type="ball-spin"
          name="userAccessControlSpinner"
          [fullScreen]="false"
        >
        </ngx-spinner>
      </div>
    </div>
  </div>
</div>
